import { useLocation, NavLink } from "react-router-dom";
import { LocaleContext } from "../contexts/LocaleContext";
import { useContext, useEffect, useState } from "react";

const Sidebar = () => {
  const { t } = useContext(LocaleContext);
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);

  // Define sidebar items in a single configuration array for easy maintenance
  const menuItems = [
    { path: "/dashboard", icon: "fas fa-home", label: "home" },
    { path: "/trips", icon: "fas fa-map-marker-alt", label: "trips" },
    { path: "/bookings", icon: "fas fa-calendar-alt", label: "bookings" },
    // { path: "/chats", icon: "fas fa-comments", label: "chats" },
    {
      path: "/transactions",
      icon: "fas fa-sack-dollar",
      label: "transactions",
    },
    { path: "/notifications", icon: "fas fa-bell", label: "notifications" },
  ];
  useEffect(() => {
    const index = sessionStorage.getItem("activeIndex");
    if (index) {
      setActiveIndex(parseInt(index));
    } else {
      setActiveIndex(0); // default page
    }
  }, []);
  /**
   * Dynamically determines the class based on proximity to the active route.
   * This replaces the manual 'handelIndex' state logic.
   */
  const handelIndex = (i) => {
    setActiveIndex(i);
    sessionStorage.setItem("activeIndex", i);
  };
  const getClassName = (index) => {
    if (index === activeIndex) return "selected";
    if (index === activeIndex - 1) return "selected-prev";
    if (index === activeIndex + 1) return "selected-next";
    return "";
  };

  return (
    <aside className={activeIndex === 0 ? "my-aside" : ""}>
      <label className="fas fa-times" htmlFor="aside-toggle"></label>
      <ul>
        <li className="">
          <a
            href="#"
            className={activeIndex === 0 ? "selected-prev hidden" : "hidden"}
          >
            <i className="fas fa-users"></i> hidden
          </a>
        </li>
        {menuItems.map((item, index) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              className={getClassName(index)}
              onClick={() => handelIndex(index)}
            >
              <i className={item.icon}></i> {t(item.label)}
            </NavLink>
          </li>
        ))}
        <li className="">
          <a
            href="#"
            className={
              activeIndex === menuItems.length - 1
                ? "selected-next hidden"
                : "hidden"
            }
          >
            <i className="fas fa-users"></i> hidden
          </a>
        </li>
      </ul>
    </aside>
  );
};

export default Sidebar;
